// Лиги по рейтингу (docs/spec/01): Bronze → Legend.

export interface LeagueDto {
  id: 'bronze' | 'silver' | 'gold' | 'diamond' | 'elite' | 'champion' | 'legend';
  name: string;
  /** нижняя граница рейтинга */
  from: number;
  color: string;
}

export const LEAGUES: readonly LeagueDto[] = [
  { id: 'bronze', name: 'Bronze', from: 0, color: '#d9a066' },
  { id: 'silver', name: 'Silver', from: 1100, color: '#c9d1d9' },
  { id: 'gold', name: 'Gold', from: 1250, color: '#ffd23f' },
  { id: 'diamond', name: 'Diamond', from: 1400, color: '#7fdcff' },
  { id: 'elite', name: 'Elite', from: 1550, color: '#b388ff' },
  { id: 'champion', name: 'Champion', from: 1700, color: '#ff6f61' },
  { id: 'legend', name: 'Legend', from: 1850, color: '#fff3b0' },
];

export interface LeagueProgress {
  league: LeagueDto;
  next: LeagueDto | null;
  /** доля пути до следующей лиги 0..1 (1 — в высшей) */
  progress: number;
  /** очков до следующей лиги (0 — в высшей) */
  toNext: number;
}

export function leagueOf(rating: number): LeagueProgress {
  let i = LEAGUES.length - 1;
  while (i > 0 && rating < LEAGUES[i]!.from) i--;
  const league = LEAGUES[i]!;
  const next = LEAGUES[i + 1] ?? null;
  if (!next) return { league, next, progress: 1, toNext: 0 };
  const start = i === 0 ? Math.min(rating, 1000) : league.from; // Bronze считаем от стартовых 1000
  return {
    league,
    next,
    progress: Math.max(0, Math.min(1, (rating - start) / (next.from - start))),
    toNext: next.from - rating,
  };
}
